module.exports = __webpack_public_path__ + "static/media/icon_chevron_right.1d953921.svg";